<template>
  <div class="zu-ct-warp zu-ct-flex" :class="isDisable ? 'is-disable' : ''" :style="tableCss" ref="table">
    <div class="zu-ct-header" :style="headerStyle">
      <div class="zu-ct-row">
        <div class="zu-ct-cell" :class="{disable : !item.edit}" v-for="(item, index) in headers" :key="index">
          <template v-if="Array.isArray(item.label)">
            <div class="header-custom" ref="custom">
              <div class="header-left">{{ item.label[0] }}</div>
              <div class="header-right">{{ item.label[1] }}</div>
              <div class="header-line" :style="lineCss"></div>
            </div>
          </template>
          <div class="zu-ct-text" v-else>
            <span class="zu-ct-span">{{ item.label }}</span>
          </div>
        </div>
      </div>
    </div>
    <div class="zu-ct-body">
      <el-form label-width="0" :model="formData" :rules="[]" ref="domains">
        <div class="zu-ct-row" v-for="(item, index) in formData.domains" :key="index">
          <template v-for="(child, idx) in item.list">
            <!-- 判断是否是特批优惠年份 -->
            <template v-if="item.key === 'discount_year'">
              <!-- 判断特批优惠金额是否有值 -->
              <template v-if="rightTotal[index - 1]">
                <div class="zu-ct-cell" :key="idx" :class="[['other'].includes(child.type) && 'other-cell', ['title', 'custom'].includes(child.type) && 'font-weight-cell', child.type === 'title' ? 'title-cell' : '', !child.edit ? 'disable' : '']">
                  <template v-if="['text'].includes(child.type) && isDetail">{{ child.value }}</template>
                  <!-- 判断左侧显示标题 -->
                  <template v-else-if="['text', 'title'].includes(formData.domains[index-1].list[idx].type)">
                    <div class="zu-ct-text">{{ child.label }}</div>
                  </template>
                  <!-- 判断显示下拉选择 -->
                  <template v-else-if="Number(formData.domains[index-1].list[idx].value)">
                    <el-form-item class="zu-ct-form-item" :prop="`domains.${index}.list.${idx}.value`" :rules="dynamicSelect">
                      <el-select
                        class="zu-ct-select"
                        v-model="child.value"
                        placeholder="请选择"
                        popper-append-to-body
                        :disabled="!isEditDisable && !child.edit"
                      >
                        <el-option v-for="third in item.options" :key="third.value" :label="third.label" :value="third.value"></el-option>
                      </el-select>
                    </el-form-item>
                  </template>
                </div>
              </template>
            </template>
            <!-- 其他数据 -->
            <template v-else>
              <div class="zu-ct-cell" :class="[['other'].includes(child.type) && 'other-cell', ['title', 'custom'].includes(child.type) && 'font-weight-cell', child.type === 'title' ? 'title-cell' : '', !child.edit ? 'disable' : '']" :key="idx">
                <template v-if="['title'].includes(child.type)">
                  <div class="zu-ct-text">{{ child.label }}</div>
                </template>
                <template v-else-if="['text'].includes(child.type)">
                  <div class="zu-ct-text">{{ child.value }}</div>
                </template>
                <template v-else-if="child.type === 'input'">
                  <el-form-item class="zu-ct-form-item" :prop="`domains.${index}.list.${idx}.value`" :rules="dynamicNumber">
                    <el-input
                      class="zu-ct-input"
                      v-model="item.list[idx].value"
                      placeholder="请输入"
                      :disabled="!isEditDisable && !child.edit"
                      @input="onInputChange($event, formData.domains[index-1].list[idx].value, index, idx)"
                    />
                  </el-form-item>
                </template>
              </div>
            </template>
          </template>
          <!-- 合计展示规则 -->
          <div class="zu-ct-cell" :class="!item.list.at(-1).edit ? 'disable' : ''" v-if="item.key !== 'discount_year' || (item.key === 'discount_year' && rightTotal[index - 1])"><div class="zu-ct-text">{{ rightTotal[index] }}</div></div>
        </div>
        <!-- 底部计算规则 -->
        <div class="zu-ct-row">
          <div v-for="(item, index) in bottomTotal" :key="index" class="zu-ct-cell" :class="[['other'].includes(item.type) && 'other-cell', ['title', 'custom'].includes(item.type) && 'font-weight-cell', item.type === 'title' ? 'title-cell' : '', !item.edit ? 'disable' : '']">
            <div class="zu-ct-text">{{ item.value }}</div>
          </div>
        </div>
      </el-form>
    </div>
    <div class="zu-ct-footer"></div>
  </div>
</template>

<script>
import { preciseAdd, preciseSubtract } from '@/utils'
import { validateNumber } from '@/utils/validate'
export default {
  props: {
    data: {type: Array, default: () => [] },
    config: {type: Array, default: () => [] },
    isDetail: {type: Boolean, default: false },
    isEditDisable: {type: Boolean, default: false },
    count: {type: Number, default: 0 },
    isPart: {type: Boolean, default: false },
    bottomText: {type: String, default: '实缴金额' },
    rightText: {type: String, default: '合计' },
    border: {type: Boolean, default: true },
    emptyText: {type: String, default: '暂无数据' },
    align: {type: String, default: 'center' },
    headerColor: {type: String, default: '#fff' },
    headerBgColor: {type: String, default: '#6B9BFC' },
    headerDisableColor: {type: String, default: '#fff' },
    headerDisableBgColor: {type: String, default: '#B6BAC8' },
    headerLineColor: {type: String, default: '#86B0FF' },
    headerStyle: {type: Object, default: () => ({}) },
    color: {type: String, default: '#333' },
    bgColor: {type: String, default: '#E1EEFF' },
    disableColor: {type: String, default: '#666' },
    disableBgColor: {type: String, default: '#E8EAF3' },
    titleBgColor: {type: String, default: '#E1EEFF' },
    borderColor: {type: String, default: '#7BB2F4' },
    customStyle: {type: Object, default: () => ({}) },
  },
  watch: {
    data: {
      handler() {
        this.changeList()
      },
      immediate: true,
      deep: true
    },
    config: {
      handler() {
        this.changeList()
      },
      deep: true
    },
    'formData.domains': {
      handler(val) {
        this.getData(val)
      },
      deep: true,
      immediate: true
    },
    count() {
      this.getData(this.formData.domains)
    }
  },
  computed: {
    newCount () {
      let num = Number(this.count) || 0
      if (num < 0) num = 0
      return num
    },
    lineCss() {
      let m = this.width
      const deg = (this.height / m) * 180 / Math.PI
      const len = Math.sqrt(Math.pow(m, 2) + Math.pow(this.height, 2))
      return {
        height: `${len}px`,
        transform: `rotate(${deg - 90}deg)`
      }
    },
    tableCss() {
      const justifyContent = {
        center: 'center',
        left: 'flex-start',
        right: 'flex-end'
      }
      const textMap = {
        center: 'center',
        left: 'left',
        right: 'right'
      }
      return {
        '--zu-justify': justifyContent[this.align] || 'center',
        '--zu-align': textMap[this.align] || 'center',
        '--zu-header-line': this.headerLineColor,
        '--zu-header-color': this.headerColor,
        '--zu-header-bg': this.headerBgColor,
        '--zu-header-disable-color': this.headerDisableColor,
        '--zu-header-disable-bg': this.headerDisableBgColor,
        '--zu-border-color': this.isDisable ? '#fff' : this.borderColor,
        '--zu-body-color': this.color,
        '--zu-body-title-bg': this.titleBgColor,
        '--zu-body-bg': this.isDisable ? '#EFF4FC' :this.bgColor,
        '--zu-body-disable-color': this.disableColor,
        '--zu-body-disable-bg': this.disableBgColor,
        ...this.customStyle
      }
    },
    rightTotal() {
      const arr = []
      this.formData.domains.forEach(item => {
        if (item.key === 'discount_year') return arr.push('')
        const num = item.list.reduce((acc, cur) => {
          let va = Number(cur.value) || 0
          if (va < 0) va = 0
          const now = preciseAdd(acc, va)
          return now
        }, 0)
        arr.push(num)
      })
      return arr
    },
    bottomTotal() {
      const arr1 = [{ type: 'title', value: this.bottomText, edit: true }]
      const arr2 = []
      let com_num = this.newCount
      this.formData.domains.forEach(item => {
        if (item.key === 'discount_year') return
        const arr3 = []
        item.list.forEach((i, j) => {
          if (i.type === 'title') return
          let val1 = Number(i.value) || 0
          if (val1 < 0) val1 = 0
          arr3.push({ type: 'text', value: val1, edit: i.edit })
          if (arr1[j]) {
            let val2 = preciseSubtract(arr1[j].value, val1)
            const nv = i.edit ? val2 : 0
            if (this.isPart) {
              if (!com_num) return arr1[j] = { type: 'text', value: 0, edit: i.edit }
              if (!i.edit) {
                arr1[j] = { type: 'text', value: 0, edit: i.edit }
                return
              }
              if (com_num >= val2) {
                const num = preciseSubtract(com_num, val2)
                com_num = num
                arr1[j] = { type: 'text', value: val2, edit: i.edit }
              } else {
                arr1[j] = { type: 'text', value: com_num, edit: i.edit }
                com_num = 0
              }
              return
            }
            arr1[j] = { type: 'text', value: nv, edit: i.edit }
          } else {
            arr1.push({ type: 'text', value: val1, edit: i.edit })
          }
        })
        arr2.push(arr3)
      })
      // const arr3 = arr2.map(i => i.reduce((a,b) => preciseAdd(a, b.value), 0))
      // let num = preciseSubtract(arr3[0], arr3[1])
      const num = arr1.reduce((a,b) => preciseAdd(a, Number(b.value) || 0), 0)
      if (this.isPart) {
        if (num > this.newCount) {
          num = this.newCount
        }
      }
      const arr = [...arr1, { type: 'text', value: num, edit: arr1.at(-1).edit }]
      return arr
    }
  },
  data() {
    return {
      height: 0,
      width: 0,
      clientWidth: 0,
      isDisable: false,
      formData: {
        domains: []
      },
      headers: [],
      source: [],
      dynamicSelect: { required: true, message: '请选择', trigger: 'change' },
      dynamicNumber: { required: true, validator: (_, value, callback) => validateNumber(value, callback, { min: 0, equalToMin: true, empty: '请输入' }), trigger: 'blur' }
    }
  },
  methods: {
    getData(val) {
      const arr = this.data.map(item => {
        const { first_price, average_price, isShow, options, ...o } = item
        const obj = { ...o }
        val.forEach(i => {
          const { list } = i
          if (i.prop === 'compute_price') return
          list.forEach((child, k) => {
            if (child.id === item.id && child.stages_id === item.goods_stages_detail_id) {
              if (i.prop === 'discount_price') {
                obj.discount_price = Number(child.value) || 0
              } else if (i.prop === 'discount_year') {
                obj.discount_year = child.value || 0
              }
              obj.price = this.bottomTotal[k].value
            }
          })
        })
        return obj
      })
      const num1 = preciseSubtract(this.rightTotal[0], this.rightTotal[1])
      const len = this.bottomTotal.length
      const num2 = this.bottomTotal[len -1].value
      const nt = arr.reduce((a,b) => preciseAdd(a, b.is_can_edit ? (Number(b.discount_price) || 0) : 0), 0)      
      const obj = {
        goods_stages: arr,
        sum_price: this.isPart ? num1 : num2,
        sum_discount_price: nt|| 0, // this.rightTotal[1]
        sum_first_price: this.isPart ? num2 : 0,
        sum_remain_price: this.isPart ? preciseSubtract(num1, num2) : 0
      }
      if (this.isDisable) {
        if (this.isPart) {
          const t1 = arr.reduce((a, b) => (b.is_can_edit ? b.compute_price : 0) + a, 0)
          const t2 = arr.reduce((a, b) => (b.is_can_edit ? b.discount_price : 0) + a, 0)
          const t3 = preciseSubtract(t1, t2)
          obj.sum_price = t3
          obj.sum_remain_price = preciseSubtract(t3, Number(this.count) || 0)
        } else {
          obj.sum_first_price = num2
        }
      }
      this.$emit('change', obj)
      this.$nextTick(() => this.resize())
    },
    changeList() {
      if (this.config.length === 0 || this.data.length === 0) return []
      const arr1 = this.config.filter(item => item.prop)
      const arr2 = []
      let isDisable = false
      arr1.forEach(item => {
        const arr3 = [ { label: item.label, type: 'title', edit: true } ]
        const type = item.type || 'text'
        this.data.forEach(i => {
          const isEdit = i.is_can_edit ?? true
          const obj = { label: i.label || '', value: i[item.prop], type, id: i.id, stages_id: i.goods_stages_detail_id, edit: isEdit }
          arr3.push(obj)
          if (!isEdit) {
            isDisable = true
          }
        })
        const obj = { label: item.label, key: item.key, prop: item.prop, list: arr3 }
        if (type === 'select') {
          obj.options = item.options
        }
        arr2.push(obj)
      })
      const s1 = this.config[0]?.label || ''
      const s2 = this.data.map(item => ({ label: item.goods_category_name, edit: item.is_can_edit ?? true }))
      this.headers = [].concat([{ label: s1, edit: true }], s2, { label: this.rightText, edit: s2.at(-1).edit })
      this.isDisable = isDisable
      this.formData.domains = JSON.parse(JSON.stringify(arr2))
    },
    onInputChange(val1, val2, index, idx) {
      let v1 = Number(val2) || 0
      let v2 = Math.abs(Number(parseInt(val1)) || 0)
      if (v2 >= v1) {
        v2 = v1
        this.formData.domains[index].list[idx].value = v2
      }
      if (!v2) {
        this.formData.domains[index+1].list[idx].value = ''
      }
    },
    submit() {
      return new Promise((resolve, reject) => {
        this.$refs['domains'].validate((valid) => {
          if (valid) {
            resolve()
          } else {
            console.log('error submit!!');
            reject()
          }
        })
      })
    },
    resize() {
      const table = this.$refs.table
      if (!table) return
      const custom = table.querySelector('.header-custom')
      if (!custom) return
      this.clientWidth = table.clientWidth || 0
      this.height = custom.clientHeight || 0
      this.width = custom.clientWidth || 0
    }
  },
  mounted() {
    this.resize()
    window.addEventListener('resize', this.resize)
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.resize)
  }
}
</script>

<style lang="scss"></style>
